import { formatRoute } from 'react-router-named-routes';
import { NavLink, withRouter } from 'react-router-dom';

const routes = {
	home: '/home',
	privacy: '/privacy',
	thanks: '/thanks'
};

export { NavLink, withRouter };
export default function(routeName, routeProps = {}) {
	const selectedRoute = routes[ routeName ];
	if (!selectedRoute) {
		throw new Error(`Can't find route for route name '${routeName}'`);
	}
	return formatRoute(selectedRoute, routeProps);
}



// WEBPACK FOOTER //
// ./src/libraries/route.js